import { PAYMENT_TYPE_OPTIONS_MAP } from "@shared/constants";
import { usePaymentManager } from "../../contexts/PaymentManagerContext";
import { WalletElementSharedProps } from "./WalletElement.props";
import StripePaymentGateway from "../../gateways/StripePaymentGateway/StripePaymentGateway";
import StripeWalletElement from "../../stripe/StripeWalletElement/StripeWalletElement.web";

/**
 * Dynamically displays a component for virtual wallet payments, such as Apple Pay, Google Pay, etc.
 *
 * Requires the PaymentManagerContext.
 */
function WalletElement(props: WalletElementSharedProps) {
  const { manager } = usePaymentManager();

  if (!manager.handler?.gateway) {
    return null;
  }

  if (manager.handler.gateway instanceof StripePaymentGateway) {
    if (
      manager.basket &&
      manager.basket.paymentType !== PAYMENT_TYPE_OPTIONS_MAP.CREDIT.id
    ) {
      return null;
    }

    return <StripeWalletElement {...props} />;
  }

  return null;
}

export default WalletElement;
